
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[category]/page/[page]",
      function () {
        return require("private-next-pages/[category]/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[category]/page/[page]"])
      });
    }
  